import styles from './style.module.scss';
import { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import FullScreenVideo from '/components/commonComponents/fullScreenVideo';
import usePolyfillVideo from '@/hooks/usePolyfillVideo';
import { useWebPResourceCompatibleFn } from '../../../hooks/useWebPResource';
import { src } from '@/utils/common';
// import StreamLakeVideo from '@/components/StreamLakeVideo';
import { DEBUG_PANEL } from '@/utils/constants.js';
import Cookies from 'js-cookie';
// import useKwaiPlayer from '@/hooks/useKwaiPlayer';
import StandardizedWebPlayer from '@/components/StreamLakeVideo/StandardizedWebPlayer';
import { Button } from 'antd';

const playerIdPrefix = 'demo-video-';

const FeatureExperienced = ({
  demoList,
  bgGradient = false,
  showPanel = false,
}) => {
  const [currentDisplay, setCurrentDisplay] = useState(0);
  const [isDebug, setIsDebug] = useState(false);

  useEffect(() => {
    const isDebug = Cookies.get(DEBUG_PANEL);
    if (isDebug && isDebug === '1') {
      setIsDebug(isDebug);
    }
  }, []);

  useEffect(() => {
    onVideoIndexChange(currentDisplay);
  }, [currentDisplay]);

  const [showPlayerControl, setShowPlayerControl] = useState(false);
  const onVideoIndexChange = (index) => {
    // 兜底逻辑，避免视频不自动播放
    setTimeout(() => {
      const id = `${playerIdPrefix}${index}`;
      const player = document.getElementById(id);
      if (player?.childNodes[0]?.play) {
        player?.childNodes[0]?.play().catch(() => {
          // 自动播放失败，显示控制条
          if (!showPlayerControl) {
            setShowPlayerControl(true);
          }
        });
      }
    }, 1000);
  };

  return (
    <main
      className={classnames({
        [styles['wrapper']]: true,
        [styles['wrapper-bgGradient']]: bgGradient,
      })}
    >
      <section className={styles['title']}>{demoList.title}</section>
      <section className={styles['content-header']}>
        {demoList.items.map((item, index) => (
          <div
            key={item.title}
            onClick={() => {
              setCurrentDisplay(index);
            }}
            className={classnames({
              [styles['header-item']]: true,
              [styles['header-item-active']]: index === currentDisplay,
            })}
          >
            {item.title}
          </div>
        ))}
      </section>
      <div className={styles.devider}></div>
      {/* 展示区 */}
      <section className={styles['content-show']}>
        {demoList.items.map((item, index) => {
          const isCurPlay = index === currentDisplay;
          return (
            <div
              key={index}
              className={classnames({
                [styles['show-item']]: true,
                [styles['show-item-active']]: isCurPlay,
                [styles['show-item-noactive']]: !isCurPlay,
              })}
            >
              <div className={styles['item-subtitle']}>{item.subTitle}</div>
              <div className={styles['item-video']} id="videoPlayerContainer">
                {
                  // 标准播放，提供videoId即可，非标准播放使用config
                  <StandardizedWebPlayer
                    id={`${playerIdPrefix}${index}`}
                    videoId={item.videoId}
                    // config={{
                    //   src: {
                    //     h264: item.videoUrl,
                    //     hevc: item.videoUrlH265,
                    //   },
                    // }}
                    showInfoPanel={isDebug && showPanel}
                    className={styles['item-video']}
                    muted
                    preload
                    autoPlay={true}
                    loop
                    controls={showPlayerControl}
                    webkit-playsinline="true"
                    playsInline={true}
                    x5-playsinline={true}
                  />
                }
              </div>
              <div className={styles['item-subtitle-mobile']}>
                {item.subTitle}
              </div>
            </div>
          );
        })}
      </section>
    </main>
  );
};

export default FeatureExperienced;
